import { IconButton } from "@material-ui/core"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch } from "react-redux"
import { dowloadVoucherAction } from "../../../ducks/voucherIndividualDuck"
import { dowloadVoucherAction as dowloadVoucherActionGrupal } from "../../../ducks/voucherGruapalDuck"
import IconDowload from "@material-ui/icons/GetApp"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"

const ButtonVoucher = (props) => {
    const { idVoucher, tipoCompra } = props
    const dispatch = useDispatch()
    const onDowload = () => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch((tipoCompra === 1) ? dowloadVoucherAction({ idDocumento: idVoucher }) : dowloadVoucherActionGrupal({ idDocumento: idVoucher })).then(Response => {
            dispatch(offLoadAction())
            if (Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            if (Response?.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null
            }
            const downloadUrl = window.URL.createObjectURL(new Blob([Response.data], { type: Response.contentType }));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.target = "_blank"
            link.download = `Compra Item ${idVoucher}`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    return (
        <div>
            <IconButton variant="outlined" color="primary" onClick={onDowload}>
                <IconDowload />
            </IconButton>
        </div>
    )
}
export default ButtonVoucher
